import { Button, Input } from "antd";
import React from "react";
import './index.sass'
export default class RefuseExamine extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    closeHandle = () => {
        this.props.colsePop({ show: false })
    }

    render() {
        return (
            <div className='refuseExamine'>

                <div className='close'></div>


                <div className='popBox'>
                    <p className='title'>
                        拒绝理由
                    </p>

                    <div className='popContent'>
                        <div className='popCtx'>
                            <div className='flex line'>
                                <label>分类名称：</label>
                                <Input.TextArea className='width280' maxLength={20} placeholder='请输入' showCount />
                            </div>

                            <div className='flex line contrlBtn mgt70'>
                                <Button className='themeBtn mgr40'>确定</Button>
                                <Button onClick={() => { this.closeHandle() }}>取消</Button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        )
    }
}